

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form22";
const form22State = namespace("Form22");

import { form22DataInfoType } from '@/types/Information/Form22';
import { partiesDataJsonDataType } from '@/types/Information/json';
import AddPartyForm from './AddPartyForm.vue';
import { partyInfoType } from '@/types/Information/Form3';

@Component({
    components:{        
        AddPartyForm        
    }
})
export default class Form22StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @form22State.State
    public form22Info: form22DataInfoType;

    @form22State.Action
    public UpdateForm22Info!: (newForm22Info: form22DataInfoType) => void  
    
    @form22State.State
    public currentNoFeesPayableId: string;

    @form22State.Action
    public UpdateCurrentNoFeesPayableId!: (newCurrentNoFeesPayableId: string) => void
    
    dataReady = false;
    updated=0; 
    updateOrderDetails = 0;
    orderDateValue = '';
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;
    latestEditRespondentData;
    isEditRespondentOpen = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;
    latestEditAppellantData;
    isEditAppellantOpen = false;

    
   
    partyFields = [
        {
            key:'organization',          
            label:'Party Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Party Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    state = { 
        appellants: null,
        respondents: null,       
        firstAppellant: null, 
        firstRespondent: null,         
        authorizedName: null, 
        applyingParties: null,    
        orders: null, 
        grounds: null, 
        income: null, 
        assets: null, 
        finances: null
    }

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }

    public partyDataExists(){

        const existsManual = this.form22Info.requiresManualEntry && 
            this.form22Info.manualAppellants.length>0 && 
            this.form22Info.manualRespondents.length>0;

        const existsSupreme = !this.form22Info.requiresManualEntry && 
            this.form22Info.appellants.length>0 && 
            this.form22Info.respondents.length>0;
            
        return existsManual || existsSupreme;
    }

    public extractInfo(){       

        if(this.currentNoFeesPayableId){
            this.getForm22Data();
           
        } else { 

            const form22Data = this.form22Info;            
            form22Data.version = this.$store.state.Application.version;
            form22Data.manualRespondents = [];
            form22Data.manualAppellants = [];
            form22Data.applyingParties = [];            

            if (this.form22Info?.requiresManualEntry){
                
                form22Data.appellants = [];
                form22Data.respondents = [];
                form22Data.appellantNames = '';
                form22Data.respondentNames = '';
                form22Data.formSevenNumber = '';

            } else {               

                let applicantNames = [];
                let respondentNames = [];               

                form22Data.appellants = this.partiesJson.appellants
                form22Data.respondents = this.partiesJson.respondents;

                for (const respondent of form22Data.respondents){
                    respondentNames.push(respondent.name);                
                }

                for (const applicant of form22Data.appellants){
                    applicantNames.push(applicant.name);                
                }

                form22Data.appellantNames = applicantNames.join(', ');
                form22Data.respondentNames = respondentNames.join(', ');      
                      
                form22Data.formSevenNumber = this.fileNumber;
            }
            this.UpdateForm22Info(form22Data);
            
            this.saveForm(true);
        }            

    }

    get partyNames(){
        
        let partyNames: string[] = [];

        if (this.form22Info.requiresManualEntry){

            for (const respondent of this.form22Info.manualRespondents){
                partyNames.push(respondent.name) 
            }

            for (const applicant of this.form22Info.manualAppellants){
                partyNames.push(applicant.name);  
            }

        } else {

            for (const respondent of this.form22Info.respondents){
                partyNames.push(respondent.name) 
            }

            for (const applicant of this.form22Info.appellants){
                partyNames.push(applicant.name);  
            }
        }      
        return partyNames;
    }  

    get applicantNames(){
        
        let applicantNames: string[] = [];

        if (this.form22Info.requiresManualEntry){            

            for (const applicant of this.form22Info.manualAppellants){
                applicantNames.push(applicant.name);  
            }

        } else {            

            for (const applicant of this.form22Info.appellants){
                applicantNames.push(applicant.name);  
            }
        }      
        return applicantNames;
    }

    get respondentNames(){
        
        let respondentNames: string[] = [];

        if (this.form22Info.requiresManualEntry){

            for (const respondent of this.form22Info.manualRespondents){
                respondentNames.push(respondent.name) 
            }            

        } else {

            for (const respondent of this.form22Info.respondents){
                respondentNames.push(respondent.name) 
            }            
        }      
        return respondentNames;
    }   

    public getForm22Data() {        
       
        this.$http.get('/form22/forms/'+this.currentNoFeesPayableId)
        .then((response) => {
            if(response?.data?.data){
                const form22Data = response.data.data
                this.UpdateForm22Info(form22Data);
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellants: null,
            respondents: null,       
            firstAppellant: null, 
            firstRespondent: null,         
            authorizedName: null, 
            applyingParties: null,    
            orders: null, 
            grounds: null, 
            income: null, 
            assets: null, 
            finances: null
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){   

        if(this.form22Info.requiresManualEntry){
            this.state.appellants = this.form22Info.manualAppellants?.length>0? null :false;
            this.state.respondents = this.form22Info.manualRespondents?.length>0? null :false;            
        } else {
            this.state.appellants = null;
            this.state.respondents = null;            
        }
        
        this.state.firstAppellant = this.form22Info.firstAppellant != null? null:false;
        this.state.firstRespondent = this.form22Info.firstRespondent != null? null:false;
        this.state.applyingParties = this.form22Info.applyingParties?.length>0? null :false;
        
        this.state.orders = this.form22Info.orders != null? null:false;
        this.state.grounds = this.form22Info.grounds != null? null:false;
        
        this.state.assets = this.form22Info.assets != null? null:false;
        this.state.income = this.form22Info.income != null? null:false;
        const financesRequired = this.form22Info.assets == false && this.form22Info.income == 0
        this.state.finances = (financesRequired && !this.form22Info.finances)? false: null;
        
        this.state.authorizedName = !this.form22Info.authorizedName? false : null;       

        if(dontFindInvalidFields == true) return true

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form22/forms';

        if (this.currentNoFeesPayableId){
            method = 'put';
            url = '/form22/forms/'+this.currentNoFeesPayableId;
            const form22Data = this.form22Info;            
            this.UpdateForm22Info(form22Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form22Info,
                    type:'Form22',
                    description:'Application For Order that No Fees are Payable'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form22Info,
                    type:'Form22',
                    description:'Application For Order that No Fees are Payable'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoFeesPayableId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }

    public addNewRespondent(){
        if(this.isEditRespondentOpen){            
            this.addRespondentFormColor = 'danger'
        }else{
            this.AddNewRespondentForm = true;            
        }
    }

    public editRespondent(data) {
        if(this.AddNewRespondentForm || this.isEditRespondentOpen){            
            this.addRespondentFormColor = 'danger';                     
        }else if(!this.isEditRespondentOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditRespondentOpen = true;
            this.latestEditRespondentData = data            
        }   
    }

    public modifyRespondentList(isCreateParty: boolean, newParty: partyInfoType, index: number){        

        if (isCreateParty){

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }

            const respondentNames = []
            const form22Data = this.form22Info;
            form22Data.manualRespondents.push(newParty)

            for (const respondent of form22Data.manualRespondents){
                respondentNames.push(respondent.name);                
            }
            form22Data.respondentNames = respondentNames.join(', '); 
            this.UpdateForm22Info(form22Data)

            this.closeRespondentForm();

        } else {  

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }  
            
            const respondentNames = [];
            const form22Data = this.form22Info;
            form22Data.manualRespondents[index].organization = newParty.organization;
            form22Data.manualRespondents[index].name = newParty.name; 
            form22Data.manualRespondents[index].firstName = newParty.firstName;
            form22Data.manualRespondents[index].lastName = newParty.lastName;

            for (const respondent of form22Data.manualRespondents){
                respondentNames.push(respondent.name);                
            }
            form22Data.respondentNames = respondentNames.join(', '); 
            this.UpdateForm22Info(form22Data);
                      
            this.closeRespondentForm();
        }
        this.updated ++;
    }

    public removeRespondent(data){ 
        const form22Data = this.form22Info;       
        form22Data.manualRespondents.splice(data.index,1);
        const respondentNames = [];
        for (const respondent of form22Data.manualRespondents){
            respondentNames.push(respondent.name);                
        }
        form22Data.respondentNames = respondentNames.join(', '); 
        this.UpdateForm22Info(form22Data);
        this.updated ++;        
    }

    public closeRespondentForm() {                     
        this.AddNewRespondentForm= false; 
        this.addRespondentFormColor = 'court'
        if(this.isEditRespondentOpen){
            this.latestEditRespondentData.toggleDetails();
            this.isEditRespondentOpen = false;
        } 
    }

    public addNewAppellant(){
        if(this.isEditAppellantOpen){            
            this.addAppellantFormColor = 'danger'
        }else{
            this.AddNewAppellantForm = true;            
        }
    }

    public editAppellant(data) {
        if(this.AddNewAppellantForm || this.isEditAppellantOpen){            
            this.addAppellantFormColor = 'danger';                     
        }else if(!this.isEditAppellantOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAppellantOpen = true;
            this.latestEditAppellantData = data            
        }   
    }
    
    public modifyAppellantList(isCreateParty: boolean, newParty: partyInfoType, index: number){        

        if (isCreateParty){ 

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }    

            const appellantNames = []
            const form22Data = this.form22Info;
            form22Data.manualAppellants.push(newParty)

            for (const appellant of form22Data.manualAppellants){
                appellantNames.push(appellant.name);                
            }
            form22Data.appellantNames = appellantNames.join(', '); 
            this.UpdateForm22Info(form22Data);

            this.closeAppellantForm();
        } else {  

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName
            } 
            
            const appellantNames = [];
            const form22Data = this.form22Info;
            form22Data.manualAppellants[index].organization = newParty.organization;
            form22Data.manualAppellants[index].name = newParty.name; 
            form22Data.manualAppellants[index].firstName = newParty.firstName;
            form22Data.manualAppellants[index].lastName = newParty.lastName;

            for (const appellant of form22Data.manualAppellants){
                appellantNames.push(appellant.name);                
            }
            form22Data.appellantNames = appellantNames.join(', '); 
            this.UpdateForm22Info(form22Data);  
            this.closeAppellantForm();
        }
        this.updated ++;
        
    }

    public removeAppellant(data){   
        const form22Data = this.form22Info;       
        form22Data.manualAppellants.splice(data.index,1);
        const appellantNames = [];
        for (const appellant of form22Data.manualAppellants){
            appellantNames.push(appellant.name);                
        }
        form22Data.appellantNames = appellantNames.join(', '); 
        this.UpdateForm22Info(form22Data);
        this.updated ++;        
    }

    public closeAppellantForm() {                     
        this.AddNewAppellantForm= false; 
        this.addAppellantFormColor = 'court'
        if(this.isEditAppellantOpen){
            this.latestEditAppellantData.toggleDetails();
            this.isEditAppellantOpen = false;
        } 
        this.recheckStates()
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form22"}) 
    }
    public handleIncomeChange() {
        if (this.form22Info.income !== 1) {
            this.form22Info.incomeValue1 = null;
        }
        if (this.form22Info.income !== 2) {
            this.form22Info.incomeValue2 = null;
        }
        this.recheckStates();
    }
    public handleAssetsChange() {
        if (this.form22Info.assets !== true) {
            this.form22Info.assetsValue = null;
        }
        this.recheckStates();
    }
}
